import React from 'react';
import { blogPosts } from '../mock/mock';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Clock } from 'lucide-react';

export default function Blog() {
  const [featured, ...rest] = blogPosts;
  return (
    <div>
      <section className="bg-teal-800 py-14 text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-teal-200 uppercase tracking-widest text-xs font-semibold">Travel tips</div>
          <h1 className="font-display font-extrabold text-3xl md:text-5xl mt-2">Stories & guides for smarter travel</h1>
          <p className="text-white/85 mt-3 max-w-2xl">Insider tips from our Singapore-based editors — covering flight hacks, packing, family travel and long-haul planning.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <Card className="lg:col-span-2 overflow-hidden border-slate-200 card-lift">
          <div className="relative aspect-[16/9] overflow-hidden">
            <img src={featured.image} alt={featured.title} className="absolute inset-0 w-full h-full object-cover" />
          </div>
          <CardContent className="p-6">
            <Badge className="bg-teal-700 text-white mb-3">{featured.category}</Badge>
            <div className="font-display font-extrabold text-2xl md:text-3xl text-slate-900">{featured.title}</div>
            <p className="text-slate-600 mt-2">{featured.excerpt}</p>
            <div className="text-xs text-slate-500 mt-4 flex items-center gap-3">
              <span>{featured.date}</span>
              <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {featured.readTime} min read</span>
            </div>
          </CardContent>
        </Card>
        <div className="space-y-5">
          {rest.map(p => (
            <Card key={p.id} className="overflow-hidden border-slate-200 card-lift">
              <div className="grid grid-cols-3">
                <div className="relative aspect-square">
                  <img src={p.image} alt={p.title} className="absolute inset-0 w-full h-full object-cover" />
                </div>
                <CardContent className="col-span-2 p-4">
                  <div className="text-xs font-semibold text-teal-700 uppercase tracking-widest">{p.category}</div>
                  <div className="font-display font-bold text-slate-900 mt-1 line-clamp-2">{p.title}</div>
                  <div className="text-xs text-slate-500 mt-2">{p.date} · {p.readTime} min</div>
                </CardContent>
              </div>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
}
